import { TimeInputWUT } from '@wix/form-fields/wut';

export default TimeInputWUT;
